import { PropsWithChildren, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useDispatchAreaStore } from '../dispatch-areas/use-dispatch-areas';
import { QueueStateContext } from '../queues/context/queue-state-context';
import { WorkspacePanel } from '../panels/workspace-panel';
import { useRegisterQueueStore } from '../queues/queue-registry/use-register-queue-store';
import { useIntegratedHospitalQueueStore } from './use-integrated-hospital-queue-store';
import { HospitalQueueStore } from './store/hospital-queue-store';
import { workspacePanelIsQueue } from '../panels/workspace-queue-exists';

export const HospitalQueueStateProvider = observer(function HospitalQueueStateProvider({
    workspacePanel,
    children,
}: PropsWithChildren<{
    workspacePanel: WorkspacePanel;
}>): React.ReactElement {
    workspacePanelIsQueue(workspacePanel);

    const dispatchAreaStore = useDispatchAreaStore();
    const dispatchAreaIds = dispatchAreaStore.monitoredAndOwnedDispatchAreaIds;
    const store = useState(() => new HospitalQueueStore(workspacePanel))[0];

    const filteredHospitalCapabilityAttributeIds = useMemo(() => {
        return store.workspacePanel.queue.hospitalCapabilityFilters.map(
            (hospitalCapabilityFilter) => hospitalCapabilityFilter.attributeId
        );
    }, [store.workspacePanel.queue.hospitalCapabilityFilters]);

    const filteredHospitalStatusAttributeIds = useMemo(() => {
        return store.workspacePanel.queue.hospitalStatusFilters.map(
            (hospitalStatusFilter) => hospitalStatusFilter.attributeId
        );
    }, [store.workspacePanel.queue.hospitalStatusFilters]);

    useRegisterQueueStore(store);

    useIntegratedHospitalQueueStore({
        workspacePanel,
        dispatchAreaIds,
        store,
        filteredHospitalCapabilityAttributeIds,
        filteredHospitalStatusAttributeIds,
    });

    return <QueueStateContext.Provider value={store}>{children}</QueueStateContext.Provider>;
});
